module.exports = __webpack_public_path__ + "img/logo.51fa1d7f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 1